import { clsx } from 'clsx';
import { useTranslation } from 'react-i18next';
import type { SyncStatus } from '@services/offline/types';

type StatusPillProps = {
  status: SyncStatus | 'synced' | 'online' | 'offline';
  dense?: boolean;
};

const styles: Record<StatusPillProps['status'], string> = {
  pending: 'bg-amber-50 text-amber-800 ring-amber-200',
  syncing: 'bg-indigo-50 text-indigo-800 ring-indigo-200',
  synced: 'bg-emerald-50 text-emerald-800 ring-emerald-200',
  error: 'bg-red-50 text-red-800 ring-red-200',
  online: 'bg-emerald-50 text-emerald-800 ring-emerald-200',
  offline: 'bg-slate-100 text-slate-700 ring-slate-300'
};

export const StatusPill = ({ status, dense }: StatusPillProps) => {
  const { t } = useTranslation();

  return (
    <span
      className={clsx(
        'inline-flex items-center rounded-full font-medium ring-1 ring-inset',
        dense ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm',
        styles[status]
      )}
    >
      {t(`sync.status.${status}`)}
    </span>
  );
};
